<template>
  <div class="grid">
    <div class="common-title" id="TEAM-BUILDING">
      <div class="common-title-content">
        双轮驱动业务模式
      </div>
    </div>
    <div class="business-show-panel">
      <div class="text">
        <p>
          公司能够为客户提供场景建设、运营一站式服务。以建设城市微场景为载体，通过落地社区、园区、校区获得海量数据，纵向支撑城市管理者决策，横向拓展商业联盟，促进区域场景布局优化。
        </p>
        <p>
          拥有标准化场景建设方案，贯穿整个流程，确保项目正常运行，避免烂尾；依托场景资源和用户资源，对接第三方服务商，为居民输送服务，实现区域场景下的需求、资源、服务、资金、人力等各种要素的高效流转，为场景注入新活力。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "business",
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.grid {
  .business-show-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5rem;
    width: 100%;
    height: 40rem;
    background-image: url("~@/assets/images/home/business.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .text {
      width: 32rem;
      color: #ffffff;

      h4 {
        padding-bottom: 1rem;
        font-size: 1.6rem;
        text-align: center;
      }
      p {
        font-size: 1.1rem;
        text-indent: 2em;
        text-align: justify;
        line-height: 1.5;
      }
    }
  }
}
</style>
